// extracted by mini-css-extract-plugin
export default {"icon":"CounterpartiesTable_icon__ou41g","actionsCell":"CounterpartiesTable_actionsCell__Hsa4s"};